import { useState } from "react";
import { useTranslation } from "react-i18next";
import "./LanguageToggle.css";

export default function LanguageToggle() {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.resolvedLanguage || "sv");
  const handleLanguageClick = (lang: string) => {
    i18n.changeLanguage(lang);
    setCurrentLang(lang);
  };
  return (
    <div>
      <button
        onClick={() => handleLanguageClick("sv")}
        className={`language-button ${currentLang === "sv" ? "active" : ""}`}
      >
        SV
      </button>
      |
      <button
        onClick={() => handleLanguageClick("en")}
        className={`language-button ${currentLang === "en" ? "active" : ""}`}
      >
        EN
      </button>
    </div>
  );
}
